(function() {
  if (window.SWHSoloProductPage) return;

  var cleanups = new Map();

  function parseConfig(section) {
    var configEl = section.querySelector('script[data-swh-solo-config]');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function initSection(section) {
    if (!section || cleanups.has(section.id)) return;

    var detailUtils = window.SWHProductDetail;
    if (!detailUtils) return;

    var config = parseConfig(section);
    if (!config) return;

    var stickyBodyClass = 'swh-solo-sticky-footer';
    var galleryBodyClassName = 'swh-solo-gallery-open';
    var listeners = [];
    var variantSelect = section.querySelector('[data-solo-variant-select]');
    var productForm = section.querySelector('[data-solo-product-form]');
    var quantityInput = section.querySelector('#SoloQuantity-' + config.sectionId);
    var variantIdInput = section.querySelector('[data-solo-variant-id-input]');
    var variantLabelEl = section.querySelector('[data-solo-variant-label]');
    var totalPriceEl = section.querySelector('[data-solo-price-total]');
    var totalInlineEl = section.querySelector('[data-solo-price-total-inline]');
    var productPriceEl = section.querySelector('[data-solo-price-product]');
    var compareWrapEl = section.querySelector('[data-solo-compare-wrap]');
    var compareEl = section.querySelector('[data-solo-compare]');
    var availabilityEl = section.querySelector('[data-solo-availability]');
    var stickyPriceEl = section.querySelector('[data-solo-sticky-price]');
    var submitTextEl = section.querySelector('[data-solo-submit-text]');
    var submitIconEl = section.querySelector('[data-solo-submit-icon]');
    var stickySubmitTextEl = section.querySelector('[data-solo-sticky-submit-text]');
    var submitBtn = section.querySelector('[data-solo-submit]');
    var stickyBtn = section.querySelector('[data-solo-sticky-button]');
    var upsellInputs = Array.prototype.slice.call(section.querySelectorAll('[data-solo-upsell]'));
    var montageInterestInputs = Array.prototype.slice.call(section.querySelectorAll('[data-solo-montage-interest]'));
    var selectedTotalEl = section.querySelector('[data-solo-selected-total]');
    var destroyBackButton = detailUtils.initBackButton(section, {
      selector: '[data-solo-back]',
      fallbackAttr: 'data-solo-back-fallback'
    });
    var galleryApi = detailUtils.initGallery(section, {
      bodyClass: galleryBodyClassName
    });

    function addListener(target, eventName, handler) {
      if (!target) return;
      target.addEventListener(eventName, handler);
      listeners.push(function() {
        target.removeEventListener(eventName, handler);
      });
    }

    function setButtonsAvailability(isAvailable) {
      [submitBtn, stickyBtn].forEach(function(button) {
        if (!button) return;
        button.disabled = !isAvailable;
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });

      if (submitTextEl) submitTextEl.textContent = isAvailable ? config.ctaText : config.soldOutCtaText;
      if (stickySubmitTextEl) stickySubmitTextEl.textContent = isAvailable ? config.ctaText : config.soldOutCtaText;
      if (submitIconEl) submitIconEl.hidden = !isAvailable;
    }

    function applyVariant(option) {
      if (!option) return;

      var productPrice = option.getAttribute('data-product-money') || '';
      var totalPrice = option.getAttribute('data-total-money') || '';
      var compare = option.getAttribute('data-compare-money') || '';
      var available = String(option.getAttribute('data-available') || '').toLowerCase() === 'true';
      var mediaId = option.getAttribute('data-featured-media-id');
      var variantTitle = option.getAttribute('data-variant-title') || '';
      var totalCents = option.getAttribute('data-total-cents') || '';

      if (productPriceEl && productPrice) productPriceEl.textContent = productPrice;
      if (totalPriceEl && totalPrice) totalPriceEl.textContent = totalPrice;
      if (totalInlineEl && totalPrice) totalInlineEl.textContent = totalPrice;
      if (stickyPriceEl && totalPrice) stickyPriceEl.textContent = totalPrice;
      if (variantLabelEl && variantTitle && variantTitle !== 'Default Title') variantLabelEl.textContent = variantTitle;

      if (compareWrapEl && compareEl) {
        if (compare) {
          compareEl.textContent = compare;
          compareWrapEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareWrapEl.setAttribute('hidden', 'hidden');
        }
      }

      if (availabilityEl) {
        availabilityEl.textContent = available ? config.inStockText : config.soldOutText;
        availabilityEl.classList.toggle('is-unavailable', !available);
      }

      if (productForm) {
        if (totalCents) productForm.dataset.soloBaseTotalCents = totalCents;
      }

      setButtonsAvailability(available);
      updateSelectedTotal();

      if (mediaId && galleryApi && typeof galleryApi.selectByMediaId === 'function') {
        galleryApi.selectByMediaId(mediaId);
      }
    }

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: config.currencyCode || 'EUR'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '€ ' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
      }
    }

    function updateSelectedTotal() {
      if (!selectedTotalEl || !productForm) return;
      var total = parseInt(productForm.dataset.soloBaseTotalCents || config.baseTotalCents || '0', 10) || 0;
      upsellInputs.forEach(function(input) {
        if (input.checked) total += parseInt(input.dataset.priceCents || '0', 10) || 0;
      });
      selectedTotalEl.textContent = formatMoney(total);
    }

    function onSubmit(event) {
      var productVariantId = variantSelect ? variantSelect.value : (variantIdInput ? variantIdInput.value : '');
      var montageInterest = montageInterestInputs.find(function(input) { return input.checked; });
      var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10) || 1);
      var lineGroup = 'solo-' + String(productVariantId);
      var submitForm;
      var lineIndex = 0;

      function appendField(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        submitForm.appendChild(input);
      }

      if (!productVariantId) return;

      event.preventDefault();

      submitForm = document.createElement('form');
      submitForm.method = 'post';
      submitForm.action = productForm.action;
      submitForm.style.display = 'none';

      appendField('items[' + lineIndex + '][id]', productVariantId);
      appendField('items[' + lineIndex + '][quantity]', String(quantity));
      appendField('items[' + lineIndex + '][properties][_swh_group]', lineGroup);
      if (montageInterest && montageInterest.value) {
        appendField('items[' + lineIndex + '][properties][Montage gewenst]', montageInterest.value);
      }
      lineIndex += 1;

      upsellInputs.forEach(function(input) {
        if (!input.checked || !input.value) return;
        appendField('items[' + lineIndex + '][id]', input.value);
        appendField('items[' + lineIndex + '][quantity]', '1');
        appendField('items[' + lineIndex + '][properties][_swh_group]', lineGroup);
        appendField('items[' + lineIndex + '][properties][_swh_upsell]', 'true');
        appendField('items[' + lineIndex + '][properties][_swh_upsell_for]', config.productTitle);
        lineIndex += 1;
      });

      document.body.appendChild(submitForm);
      submitForm.submit();
    }

    document.body.classList.add(stickyBodyClass);

    if (variantSelect) {
      addListener(variantSelect, 'change', function() {
        applyVariant(variantSelect.options[variantSelect.selectedIndex]);
      });
      applyVariant(variantSelect.options[variantSelect.selectedIndex]);
    }

    if (productForm) {
      addListener(productForm, 'submit', onSubmit);
    }
    upsellInputs.forEach(function(input) {
      addListener(input, 'change', updateSelectedTotal);
    });
    updateSelectedTotal();

    cleanups.set(section.id, function() {
      listeners.splice(0).forEach(function(removeListener) {
        removeListener();
      });
      if (galleryApi && typeof galleryApi.close === 'function') galleryApi.close();
      document.body.classList.remove(stickyBodyClass);
      document.body.classList.remove(galleryBodyClassName);
      if (galleryApi && typeof galleryApi.destroy === 'function') galleryApi.destroy();
      if (typeof destroyBackButton === 'function') destroyBackButton();
      cleanups.delete(section.id);
    });
  }

  function cleanupSection(section) {
    if (!section) return;
    var cleanup = cleanups.get(section.id);
    if (typeof cleanup === 'function') cleanup();
  }

  function initAllSections() {
    document.querySelectorAll('.shopify-section.product-solo').forEach(initSection);
  }

  function onReady() {
    if (!window.SWHProductDetail) {
      window.addEventListener('swh:product-detail:ready', onReady, { once: true });
      return;
    }

    initAllSections();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && event.target.classList && event.target.classList.contains('product-solo')) {
      initSection(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target && event.target.classList && event.target.classList.contains('product-solo')) {
      cleanupSection(event.target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  window.SWHSoloProductPage = {
    initSection: initSection,
    cleanupSection: cleanupSection
  };
})();
